module.exports = __webpack_public_path__ + "img/zip.083c04ae.svg";